<div style="display:flex; justify-content:center; align-items:center; gap:8px; margin:16px 0;">
  <ng-container *ngIf="menuBar$ | async as menus" >
    <ng-container *ngFor="let menu of menus.menus;">
      <div style="display:flex; flex-direction:column; align-items:center; gap:4px; position:relative;">
        <button mat-raised-button (click)="goToWeek(menu.week, menu.year)"
          [ngClass]="{'hide': isChanged, 'active-week': menu.week == week.week(), 'current-week': menu.week == currentWeek.week(), 'menu-is-locked': menu.locked && menu.week != currentWeek.week(), 'menu-is-draft': !menu.locked && menu.menuExists, 'menu-is-empty': !menu.locked && !menu.menuExists}"
          style="padding:6px 10px; line-height:1; min-height: 50px">
          <div style="font-size:11px; opacity: 0.6; margin-bottom:2px;">{{ menu.year }}</div>
          <div [ngClass]="{'past-week': menu.week < currentWeek.week()}" style="font-size:14px; font-weight:500;">{{
            menu.week }} </div>
          <div style="font-size:11px; opacity: 0.6; margin-top:2px;">{{ menu.extraText }}</div>
        </button>

        <div class="menu-preview-box" *ngIf="menu.menuExists">
          <!-- {{  menus.stockingSettings | json}} -->
          <!-- {{ toPreviewList(menu.menuExists.data) | json }} -->
          @for(category of getCategories(menus.stockingSettings); track category; let i = $index){
          <strong>{{ category | titlecase }}</strong>
          @for(productName of getProductNameInCategory(category, menus.stockingSettings, menu.menuExists.data); track
          productName; let i = $index){
          <div [ngClass]="{'no-product': productName === 'NO PRODUCT'}">{{ productName }}</div>
          }
          }
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>

<!-- <div style="text-align: center; margin-top: 20px;">
  <h3>Week {{ week.format('WW') }} - {{ week.format('YYYY') }}</h3>
</div> -->



<div>

  <ng-container *ngIf="menuItems$ | async as menuItems; else loadingTemplate">
    <!-- <form style="margin: 30px auto; max-width: 600px; text-align: center;">
      <mat-form-field style="width: 100%;">
        <mat-label>Import JSON Data</mat-label>
        <textarea matInput rows="6" [formControl]="importJsonDataTextArea" name="importJsonData"
          placeholder="{'BAGUETTE A': {'name':'Chicken Cæsar Grov', 'amounts':[120,110,110,110,110]}}"></textarea>
      </mat-form-field>
      <br>
      <button mat-raised-button color="accent" (click)="importJson(menuItems)" style="margin-top: 10px;">
        <mat-icon>publish</mat-icon>
        Import
      </button>
    </form> -->

    <div style="display: flex; justify-content: center; align-items: center; width:100%" *ngIf="!locked || isAdmin">
      <div>
        <button mat-raised-button color="primary" (click)="openDialog()" style="margin: 20px;">
          <mat-icon>file_copy</mat-icon>
          Copy</button>
      </div>
      <div style="flex-grow: 1; text-align: center;">
        <h4 style="color: #3f51b5">Total: {{ totals['grandTotal']?.all }} <strong *ngIf="isChanged"> - Unsaved
            changes!</strong></h4>

        <!-- <strong><mat-icon style="margin-right: 8px; color: #856404;">warning</mat-icon>Unsaved changes!</strong></span> -->
        <!-- <div *ngIf="isChanged" style="display: flex; justify-content: center; margin-bottom: 16px;">
          <mat-card
            style="background: #fff3cd; color: #856404; border: 1px solid #ffeeba; max-width: 350px; box-shadow: none;">
            <mat-card-content style="display: flex; align-items: center;">
              <mat-icon style="margin-right: 8px; color: #856404;">warning</mat-icon>
              <span><strong>Unsaved changes!</strong></span>
            </mat-card-content>
          </mat-card>
        </div> -->
      </div>
      <div style="display:flex; align-items:center; gap:8px;">
        <mat-form-field appearance="outline" style="width:280px;" matTooltip="If you're swapping or removing a product, customers who already ordered it will be emailed automatically with this reason.">
          <mat-label>Reason for change (optional)</mat-label>
          <input matInput [(ngModel)]="changeReason" name="changeReason" placeholder="e.g. supplier ran out">
        </mat-form-field>
        <button mat-raised-button (click)="onLockMenu(menuItems)" style="margin: 20px">
          <mat-icon *ngIf="locked">lock</mat-icon>
          <mat-icon *ngIf="!locked">lock_open</mat-icon>
          <span *ngIf="locked">Unlock</span>
          <span *ngIf="!locked">Lock</span>

        </button>
        <button mat-raised-button color="primary" (click)="saveMenu(menuItems)" style="margin: 20px">
          <mat-icon>save</mat-icon>
          Save
        </button>
      </div>
    </div>
    <form class="example-form">
      @for(category of menuItems.categories; track category; let i = $index){
      <mat-expansion-panel class="expansion-panel" expanded [ngClass]="{'menu-locked': locked}">
        <mat-expansion-panel-header>
          <mat-panel-title class="expansion-panel-header-text">{{ category | titlecase }}</mat-panel-title>
          <mat-panel-description>
            <div class="expansion-panel-header">
              <div class="description-spacer">
                <img *ngIf="isGlutenFreeCategory(category, menuItems)" src="assets/images/gluten-free-icon.png"
                  width="30">
                <img *ngIf="isVegetarCategory(category, menuItems)" src="assets/images/vegan-icon.png" width="30"
                  class="vegan-icon">
              </div>
              <div class="category-total"> {{totals['grandTotal']?.categories[category] || 0}}</div>
            </div>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <table mat-table [dataSource]="getDataSource(category, menuItems)" class="menu-table"
          [ngClass]="{'menu-locked': locked}">
          <ng-container matColumnDef="product">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let productType">
              <ng-container *ngIf="!locked">
                <mat-form-field class="select-product-form-field form-field">
                  <mat-label>{{productType}}</mat-label>
                  <input #productInput type="text" placeholder="None" aria-label="Number" matInput
                    class="input-auto-select" [formControl]="myControl[productType].product" [matAutocomplete]="auto"
                    (focus)="selectAll($event)">
                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn"
                    (optionSelected)="onOptionSelected($event, productInput)">
                    <mat-option *ngFor="let option of (getFilterdProducts(productType, menuItems) | async)"
                      [value]="option" [disabled]="locked">
                      {{ option.name }}
                    </mat-option>
                  </mat-autocomplete>
                </mat-form-field>
              </ng-container>
              <ng-container *ngIf="locked && menuItems.products[productType]?.product?.name">
                <mat-form-field class="select-product-form-field form-field" appearance="fill" disabled>
                  <mat-label>{{productType}}</mat-label>
                  <input matInput [value]="myControl[productType].product.value.name" disabled="true" readonly>
                </mat-form-field>
              </ng-container>
            </td>

            <td mat-footer-cell *matFooterCellDef> </td>

          </ng-container>
          <ng-container matColumnDef="vegan">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let productType">
              <ng-container *ngIf="getProduct(productType, menuItems) as product">
                <img *ngIf="product.isGlutenFri" src="assets/images/gluten-free-icon.png" width="30">
                <img *ngIf="product.isVegetar" src="assets/images/vegan-icon.png" width="30" class="vegan-icon">
                <span *ngIf="product.isNew" class="new-text">New</span>
                <span *ngIf="product.isNewRes" class="new-text">NewRes</span>
              </ng-container>
            </td>
            <td mat-footer-cell *matFooterCellDef> </td>

          </ng-container>
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let productType">
              <ng-container *ngIf="getProduct(productType, menuItems) as product">
                <button mat-icon-button [matTooltip]="product.description" matTooltipClass="example-tooltip-uppercase">
                  <mat-icon>menu</mat-icon>
                </button>
              </ng-container>
            </td>
            <td mat-footer-cell *matFooterCellDef> </td>

          </ng-container>
          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let productType">

              <ng-container *ngIf="getProduct(productType, menuItems) as product">
                {{ product.price }},-
              </ng-container>
            </td>
            <td mat-footer-cell *matFooterCellDef> </td>

          </ng-container>
          @for(day of days; track day; let i = $index){
          <ng-container [matColumnDef]="day">
            <th mat-header-cell *matHeaderCellDef [ngClass]="{'hollyday-text': menuItems.hollydaysThisWeek[i]}"
              class="table-header">
              {{menuItems.dayStrings[i]}}
              <br>
              <ng-container *ngIf="menuItems.hollydaysThisWeek[i]">
                <div class="hollyday-description">{{menuItems.hollydaysThisWeek[i].description}}</div>
              </ng-container>
            </th>
            <td mat-cell *matCellDef="let productType">


              <input [name]="productType + '_' + i" [formControl]="myControl[productType].amounts[i]" type="number"
                class="input" (ngModelChange)="onAmountChange($event, category, productType, i, menuItems)"
                [ngClass]="{'hollyday-input': menuItems.hollydaysThisWeek[i]}" />
            </td>
            <td mat-footer-cell *matFooterCellDef class="sum-footer"
              [ngClass]="{'hollyday-text': menuItems.hollydaysThisWeek[i]}">
              {{ totals['categories']?.[category]?.[i] || 0 }}
            </td>
          </ng-container>
          }

          <ng-container matColumnDef="total">
            <th mat-header-cell *matHeaderCellDef class="table-header">Total</th>
            <td mat-cell *matCellDef="let productType" class="total-coumn">
              {{ totals['productTypes']?.[productType] }}
            </td>
            <td mat-footer-cell *matFooterCellDef class="total-footer">
              <!-- {{ getTotalForCategory(category) }} -->
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
        </table>
      </mat-expansion-panel>
      }
      <!-- <div style="display: flex; justify-content: center; align-items: center; width:100%;" *ngIf="!locked">
        <div>
          <button mat-raised-button color="primary" (click)="openDialog()" style="margin: 20px;">
            <mat-icon>file_copy</mat-icon>
            Copy</button>
        </div>
        <div style="flex-grow: 1; text-align: center;">

        </div>
        <div>
          <button mat-raised-button (click)="onLockMenu(menuItems)" style="margin: 20px">
            <mat-icon *ngIf="locked">lock</mat-icon>
            <mat-icon *ngIf="!locked">lock_open</mat-icon>
            Lock</button>
          <button mat-raised-button color="primary" (click)="saveMenu()" style="margin: 20px">
            <mat-icon>save</mat-icon>
            Save
          </button>
        </div>
      </div> -->
    </form>

  </ng-container>

  <!--<form style="margin: 30px auto; max-width: 600px; text-align: center;">
    <mat-form-field style="width: 100%;">
      <mat-label>Export JSON Data</mat-label>
      <textarea matInput rows="6" [value]="getExportJsonDataAsTSV()" name="exportJsonData" readonly></textarea>
    </mat-form-field>
  </form> -->
</div>


<ng-template #loadingTemplate>
  <div style="display: flex; justify-content: center; align-items: center; width:100%; padding-top: 50px;">
    <app-spinner-loading></app-spinner-loading>
  </div>
</ng-template>


<!-- <ng-container  *ngFor="let product of products$ | async" class="menu-card">
      {{product | json}} <br>
  </ng-container> -->
<style>

</style>